import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  AddDeliveryRegionOptions,
  AddDeliveryRegionResponse,
  BulkCreateLocalDeliveryOptionApplicationErrors,
  BulkCreateLocalDeliveryOptionResponse,
  BulkUpdateLocalDeliveryOptionResponse,
  CreateLocalDeliveryOptionApplicationErrors,
  DeleteLocalDeliveryOptionOptions,
  GetLocalDeliveryOptionOptions,
  ListLocalDeliveryOptionsResponse,
  LocalDeliveryOption,
  LocalDeliveryOptionQuery,
  LocalDeliveryOptionsQueryBuilder,
  QueryLocalDeliveryOptionsResponse,
  RemoveDeliveryRegionOptions,
  RemoveDeliveryRegionResponse,
  UpdateLocalDeliveryOption,
  addDeliveryRegion as universalAddDeliveryRegion,
  bulkCreateLocalDeliveryOption as universalBulkCreateLocalDeliveryOption,
  bulkDeleteLocalDeliveryOption as universalBulkDeleteLocalDeliveryOption,
  bulkUpdateLocalDeliveryOption as universalBulkUpdateLocalDeliveryOption,
  createLocalDeliveryOption as universalCreateLocalDeliveryOption,
  deleteLocalDeliveryOption as universalDeleteLocalDeliveryOption,
  getLocalDeliveryOption as universalGetLocalDeliveryOption,
  listLocalDeliveryOptions as universalListLocalDeliveryOptions,
  queryLocalDeliveryOptions as universalQueryLocalDeliveryOptions,
  removeDeliveryRegion as universalRemoveDeliveryRegion,
  typedQueryLocalDeliveryOptions as universalTypedQueryLocalDeliveryOptions,
  updateLocalDeliveryOption as universalUpdateLocalDeliveryOption,
} from './ecom-v1-local-delivery-option-local-delivery-options.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/ecom' };

export function createLocalDeliveryOption(
  httpClient: HttpClient
): CreateLocalDeliveryOptionSignature {
  return (
    localDeliveryOption: NonNullablePaths<
      LocalDeliveryOption,
      | `areaName`
      | `cityConfig.cityItems.${number}.cityName`
      | `cityConfig.cityItems.${number}.country`
      | `radiusConfig.address`
      | `radiusConfig.address.formatted`
      | `radiusConfig.address.location`
      | `rate`
      | `scheduledDeliveryConfig.days.friday`
      | `scheduledDeliveryConfig.days.friday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.monday`
      | `scheduledDeliveryConfig.days.monday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.saturday`
      | `scheduledDeliveryConfig.days.saturday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.sunday`
      | `scheduledDeliveryConfig.days.sunday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.thursday`
      | `scheduledDeliveryConfig.days.thursday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.tuesday`
      | `scheduledDeliveryConfig.days.tuesday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.wednesday`
      | `scheduledDeliveryConfig.days.wednesday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.handlingDays`,
      8
    >
  ) =>
    universalCreateLocalDeliveryOption(
      localDeliveryOption,
      // @ts-ignore
      { httpClient }
    );
}

interface CreateLocalDeliveryOptionSignature {
  /** */
  (
    localDeliveryOption: NonNullablePaths<
      LocalDeliveryOption,
      | `areaName`
      | `cityConfig.cityItems.${number}.cityName`
      | `cityConfig.cityItems.${number}.country`
      | `radiusConfig.address`
      | `radiusConfig.address.formatted`
      | `radiusConfig.address.location`
      | `rate`
      | `scheduledDeliveryConfig.days.friday`
      | `scheduledDeliveryConfig.days.friday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.monday`
      | `scheduledDeliveryConfig.days.monday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.saturday`
      | `scheduledDeliveryConfig.days.saturday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.sunday`
      | `scheduledDeliveryConfig.days.sunday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.thursday`
      | `scheduledDeliveryConfig.days.thursday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.tuesday`
      | `scheduledDeliveryConfig.days.tuesday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.wednesday`
      | `scheduledDeliveryConfig.days.wednesday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.handlingDays`,
      8
    >
  ): Promise<
    NonNullablePaths<
      LocalDeliveryOption,
      | `zipConfig.zipCodes`
      | `radiusConfig.radius`
      | `radiusConfig.lengthUnit`
      | `customAreaConfig.geocodes`
      | `cityConfig.cityItems`
      | `cityConfig.cityItems.${number}.cityName`
      | `cityConfig.cityItems.${number}.country`
      | `destinations`
      | `destinations.${number}.code`
      | `scheduledDeliveryConfig.days.monday.timeSlots`
      | `scheduledDeliveryConfig.timeWindows`
      | `scheduledDeliveryConfig.timeWindows.${number}.day`
      | `scheduledDeliveryConfig.timeWindows.${number}.start.hours`
      | `scheduledDeliveryConfig.timeWindows.${number}.start.minutes`
      | `rates`
      | `rates.${number}.amount`
      | `rates.${number}.multiplyByQuantity`
      | `deliveryRegionIds`,
      6
    > & {
      __applicationErrorsType?: CreateLocalDeliveryOptionApplicationErrors;
    }
  >;
}

export function getLocalDeliveryOption(
  httpClient: HttpClient
): GetLocalDeliveryOptionSignature {
  return (
    localDeliveryOptionId: string,
    options?: GetLocalDeliveryOptionOptions
  ) =>
    universalGetLocalDeliveryOption(
      localDeliveryOptionId,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface GetLocalDeliveryOptionSignature {
  /** */
  (
    localDeliveryOptionId: string,
    options?: GetLocalDeliveryOptionOptions
  ): Promise<
    NonNullablePaths<
      LocalDeliveryOption,
      | `zipConfig.zipCodes`
      | `radiusConfig.radius`
      | `radiusConfig.lengthUnit`
      | `customAreaConfig.geocodes`
      | `cityConfig.cityItems`
      | `cityConfig.cityItems.${number}.cityName`
      | `cityConfig.cityItems.${number}.country`
      | `destinations`
      | `destinations.${number}.code`
      | `scheduledDeliveryConfig.days.monday.timeSlots`
      | `scheduledDeliveryConfig.timeWindows`
      | `scheduledDeliveryConfig.timeWindows.${number}.day`
      | `scheduledDeliveryConfig.timeWindows.${number}.start.hours`
      | `scheduledDeliveryConfig.timeWindows.${number}.start.minutes`
      | `rates`
      | `rates.${number}.amount`
      | `rates.${number}.multiplyByQuantity`
      | `deliveryRegionIds`,
      6
    >
  >;
}

export function listLocalDeliveryOptions(
  httpClient: HttpClient
): ListLocalDeliveryOptionsSignature {
  return (externalId: string) =>
    universalListLocalDeliveryOptions(
      externalId,
      // @ts-ignore
      { httpClient }
    );
}

interface ListLocalDeliveryOptionsSignature {
  /** @deprecated method is deprecated due to the fact that external_id is deprecated */
  (externalId: string): Promise<
    NonNullablePaths<
      ListLocalDeliveryOptionsResponse,
      | `localDeliveryOptions`
      | `localDeliveryOptions.${number}.radiusConfig.radius`
      | `localDeliveryOptions.${number}.radiusConfig.lengthUnit`,
      5
    >
  >;
}

export function queryLocalDeliveryOptions(
  httpClient: HttpClient
): QueryLocalDeliveryOptionsSignature {
  return () =>
    universalQueryLocalDeliveryOptions(
      // @ts-ignore
      { httpClient }
    );
}

interface QueryLocalDeliveryOptionsSignature {
  /**
   * Retrieves a list of local delivery options, given the provided paging, filtering, and sorting.
   *
   * To learn about working with _Query_ endpoints, see
   * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
   * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/sorting-and-paging),
   * and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
   */
  (): LocalDeliveryOptionsQueryBuilder;
}

export function typedQueryLocalDeliveryOptions(
  httpClient: HttpClient
): TypedQueryLocalDeliveryOptionsSignature {
  return (query: LocalDeliveryOptionQuery) =>
    universalTypedQueryLocalDeliveryOptions(
      query,
      // @ts-ignore
      { httpClient }
    );
}

interface TypedQueryLocalDeliveryOptionsSignature {
  /** */
  (query: LocalDeliveryOptionQuery): Promise<
    NonNullablePaths<
      QueryLocalDeliveryOptionsResponse,
      | `localDeliveryOptions`
      | `localDeliveryOptions.${number}.radiusConfig.radius`
      | `localDeliveryOptions.${number}.radiusConfig.lengthUnit`,
      5
    >
  >;
}

export function updateLocalDeliveryOption(
  httpClient: HttpClient
): UpdateLocalDeliveryOptionSignature {
  return (
    _id: string,
    localDeliveryOption: NonNullablePaths<
      UpdateLocalDeliveryOption,
      | `cityConfig.cityItems.${number}.cityName`
      | `cityConfig.cityItems.${number}.country`
      | `radiusConfig.address`
      | `radiusConfig.address.formatted`
      | `radiusConfig.address.location`
      | `scheduledDeliveryConfig.days.friday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.monday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.saturday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.sunday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.thursday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.tuesday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.wednesday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.handlingDays`,
      8
    >
  ) =>
    universalUpdateLocalDeliveryOption(
      _id,
      localDeliveryOption,
      // @ts-ignore
      { httpClient }
    );
}

interface UpdateLocalDeliveryOptionSignature {
  /** @param - LocalDeliveryOptionId - unique identifier of local delivery option */
  (
    _id: string,
    localDeliveryOption: NonNullablePaths<
      UpdateLocalDeliveryOption,
      | `cityConfig.cityItems.${number}.cityName`
      | `cityConfig.cityItems.${number}.country`
      | `radiusConfig.address`
      | `radiusConfig.address.formatted`
      | `radiusConfig.address.location`
      | `scheduledDeliveryConfig.days.friday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.monday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.saturday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.sunday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.thursday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.tuesday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.wednesday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.handlingDays`,
      8
    >
  ): Promise<
    NonNullablePaths<
      LocalDeliveryOption,
      | `zipConfig.zipCodes`
      | `radiusConfig.radius`
      | `radiusConfig.lengthUnit`
      | `customAreaConfig.geocodes`
      | `cityConfig.cityItems`
      | `cityConfig.cityItems.${number}.cityName`
      | `cityConfig.cityItems.${number}.country`
      | `destinations`
      | `destinations.${number}.code`
      | `scheduledDeliveryConfig.days.monday.timeSlots`
      | `scheduledDeliveryConfig.timeWindows`
      | `scheduledDeliveryConfig.timeWindows.${number}.day`
      | `scheduledDeliveryConfig.timeWindows.${number}.start.hours`
      | `scheduledDeliveryConfig.timeWindows.${number}.start.minutes`
      | `rates`
      | `rates.${number}.amount`
      | `rates.${number}.multiplyByQuantity`
      | `deliveryRegionIds`,
      6
    >
  >;
}

export function deleteLocalDeliveryOption(
  httpClient: HttpClient
): DeleteLocalDeliveryOptionSignature {
  return (
    localDeliveryOptionId: string,
    options?: DeleteLocalDeliveryOptionOptions
  ) =>
    universalDeleteLocalDeliveryOption(
      localDeliveryOptionId,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface DeleteLocalDeliveryOptionSignature {
  /** */
  (
    localDeliveryOptionId: string,
    options?: DeleteLocalDeliveryOptionOptions
  ): Promise<void>;
}

export function bulkCreateLocalDeliveryOption(
  httpClient: HttpClient
): BulkCreateLocalDeliveryOptionSignature {
  return (
    localDeliveryOptions: NonNullablePaths<
      LocalDeliveryOption,
      | `cityConfig.cityItems.${number}.cityName`
      | `cityConfig.cityItems.${number}.country`
      | `radiusConfig.address`
      | `radiusConfig.address.formatted`
      | `radiusConfig.address.location`
      | `scheduledDeliveryConfig.days.friday`
      | `scheduledDeliveryConfig.days.friday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.monday`
      | `scheduledDeliveryConfig.days.monday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.saturday`
      | `scheduledDeliveryConfig.days.saturday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.sunday`
      | `scheduledDeliveryConfig.days.sunday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.thursday`
      | `scheduledDeliveryConfig.days.thursday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.tuesday`
      | `scheduledDeliveryConfig.days.tuesday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.wednesday`
      | `scheduledDeliveryConfig.days.wednesday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.handlingDays`,
      8
    >[]
  ) =>
    universalBulkCreateLocalDeliveryOption(
      localDeliveryOptions,
      // @ts-ignore
      { httpClient }
    );
}

interface BulkCreateLocalDeliveryOptionSignature {
  /** */
  (
    localDeliveryOptions: NonNullablePaths<
      LocalDeliveryOption,
      | `cityConfig.cityItems.${number}.cityName`
      | `cityConfig.cityItems.${number}.country`
      | `radiusConfig.address`
      | `radiusConfig.address.formatted`
      | `radiusConfig.address.location`
      | `scheduledDeliveryConfig.days.friday`
      | `scheduledDeliveryConfig.days.friday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.monday`
      | `scheduledDeliveryConfig.days.monday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.saturday`
      | `scheduledDeliveryConfig.days.saturday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.sunday`
      | `scheduledDeliveryConfig.days.sunday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.thursday`
      | `scheduledDeliveryConfig.days.thursday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.tuesday`
      | `scheduledDeliveryConfig.days.tuesday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.wednesday`
      | `scheduledDeliveryConfig.days.wednesday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.handlingDays`,
      8
    >[]
  ): Promise<
    NonNullablePaths<
      BulkCreateLocalDeliveryOptionResponse,
      | `localDeliveryOptions`
      | `localDeliveryOptions.${number}.radiusConfig.radius`
      | `localDeliveryOptions.${number}.radiusConfig.lengthUnit`
      | `errors`
      | `errors.${number}._id`
      | `errors.${number}.error`,
      5
    > & {
      __applicationErrorsType?: BulkCreateLocalDeliveryOptionApplicationErrors;
    }
  >;
}

export function bulkUpdateLocalDeliveryOption(
  httpClient: HttpClient
): BulkUpdateLocalDeliveryOptionSignature {
  return (
    localDeliveryOptions: NonNullablePaths<
      LocalDeliveryOption,
      | `cityConfig.cityItems.${number}.cityName`
      | `cityConfig.cityItems.${number}.country`
      | `radiusConfig.address`
      | `radiusConfig.address.formatted`
      | `radiusConfig.address.location`
      | `scheduledDeliveryConfig.days.friday`
      | `scheduledDeliveryConfig.days.friday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.monday`
      | `scheduledDeliveryConfig.days.monday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.saturday`
      | `scheduledDeliveryConfig.days.saturday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.sunday`
      | `scheduledDeliveryConfig.days.sunday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.thursday`
      | `scheduledDeliveryConfig.days.thursday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.tuesday`
      | `scheduledDeliveryConfig.days.tuesday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.wednesday`
      | `scheduledDeliveryConfig.days.wednesday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.handlingDays`,
      8
    >[]
  ) =>
    universalBulkUpdateLocalDeliveryOption(
      localDeliveryOptions,
      // @ts-ignore
      { httpClient }
    );
}

interface BulkUpdateLocalDeliveryOptionSignature {
  /** */
  (
    localDeliveryOptions: NonNullablePaths<
      LocalDeliveryOption,
      | `cityConfig.cityItems.${number}.cityName`
      | `cityConfig.cityItems.${number}.country`
      | `radiusConfig.address`
      | `radiusConfig.address.formatted`
      | `radiusConfig.address.location`
      | `scheduledDeliveryConfig.days.friday`
      | `scheduledDeliveryConfig.days.friday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.friday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.monday`
      | `scheduledDeliveryConfig.days.monday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.monday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.saturday`
      | `scheduledDeliveryConfig.days.saturday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.saturday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.sunday`
      | `scheduledDeliveryConfig.days.sunday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.sunday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.thursday`
      | `scheduledDeliveryConfig.days.thursday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.thursday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.tuesday`
      | `scheduledDeliveryConfig.days.tuesday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.tuesday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.days.wednesday`
      | `scheduledDeliveryConfig.days.wednesday.enabledForDelivery`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.from`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.from.hours`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.from.minutes`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.to`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.to.hours`
      | `scheduledDeliveryConfig.days.wednesday.timeSlots.${number}.to.minutes`
      | `scheduledDeliveryConfig.handlingDays`,
      8
    >[]
  ): Promise<
    NonNullablePaths<
      BulkUpdateLocalDeliveryOptionResponse,
      | `localDeliveryOptions`
      | `localDeliveryOptions.${number}.radiusConfig.radius`
      | `localDeliveryOptions.${number}.radiusConfig.lengthUnit`
      | `errors`
      | `errors.${number}._id`
      | `errors.${number}.error`,
      5
    >
  >;
}

export function bulkDeleteLocalDeliveryOption(
  httpClient: HttpClient
): BulkDeleteLocalDeliveryOptionSignature {
  return (ids: string[]) =>
    universalBulkDeleteLocalDeliveryOption(
      ids,
      // @ts-ignore
      { httpClient }
    );
}

interface BulkDeleteLocalDeliveryOptionSignature {
  /** */
  (ids: string[]): Promise<void>;
}

export function addDeliveryRegion(
  httpClient: HttpClient
): AddDeliveryRegionSignature {
  return (
    deliveryRegionId: string,
    options?: NonNullablePaths<
      AddDeliveryRegionOptions,
      `localDeliveryOptionId`,
      2
    >
  ) =>
    universalAddDeliveryRegion(
      deliveryRegionId,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface AddDeliveryRegionSignature {
  /** */
  (
    deliveryRegionId: string,
    options?: NonNullablePaths<
      AddDeliveryRegionOptions,
      `localDeliveryOptionId`,
      2
    >
  ): Promise<
    NonNullablePaths<
      AddDeliveryRegionResponse,
      | `localDeliveryOption.zipConfig.zipCodes`
      | `localDeliveryOption.radiusConfig.radius`
      | `localDeliveryOption.radiusConfig.lengthUnit`
      | `localDeliveryOption.customAreaConfig.geocodes`
      | `localDeliveryOption.cityConfig.cityItems`
      | `localDeliveryOption.cityConfig.cityItems.${number}.cityName`
      | `localDeliveryOption.cityConfig.cityItems.${number}.country`
      | `localDeliveryOption.destinations`
      | `localDeliveryOption.destinations.${number}.code`
      | `localDeliveryOption.scheduledDeliveryConfig.days.monday.timeSlots`
      | `localDeliveryOption.scheduledDeliveryConfig.timeWindows`
      | `localDeliveryOption.scheduledDeliveryConfig.timeWindows.${number}.day`
      | `localDeliveryOption.scheduledDeliveryConfig.timeWindows.${number}.start.hours`
      | `localDeliveryOption.scheduledDeliveryConfig.timeWindows.${number}.start.minutes`
      | `localDeliveryOption.rates`
      | `localDeliveryOption.rates.${number}.amount`
      | `localDeliveryOption.rates.${number}.multiplyByQuantity`
      | `localDeliveryOption.deliveryRegionIds`,
      7
    >
  >;
}

export function removeDeliveryRegion(
  httpClient: HttpClient
): RemoveDeliveryRegionSignature {
  return (
    deliveryRegionId: string,
    options?: NonNullablePaths<
      RemoveDeliveryRegionOptions,
      `localDeliveryOptionId`,
      2
    >
  ) =>
    universalRemoveDeliveryRegion(
      deliveryRegionId,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface RemoveDeliveryRegionSignature {
  /** */
  (
    deliveryRegionId: string,
    options?: NonNullablePaths<
      RemoveDeliveryRegionOptions,
      `localDeliveryOptionId`,
      2
    >
  ): Promise<
    NonNullablePaths<
      RemoveDeliveryRegionResponse,
      | `localDeliveryOption.zipConfig.zipCodes`
      | `localDeliveryOption.radiusConfig.radius`
      | `localDeliveryOption.radiusConfig.lengthUnit`
      | `localDeliveryOption.customAreaConfig.geocodes`
      | `localDeliveryOption.cityConfig.cityItems`
      | `localDeliveryOption.cityConfig.cityItems.${number}.cityName`
      | `localDeliveryOption.cityConfig.cityItems.${number}.country`
      | `localDeliveryOption.destinations`
      | `localDeliveryOption.destinations.${number}.code`
      | `localDeliveryOption.scheduledDeliveryConfig.days.monday.timeSlots`
      | `localDeliveryOption.scheduledDeliveryConfig.timeWindows`
      | `localDeliveryOption.scheduledDeliveryConfig.timeWindows.${number}.day`
      | `localDeliveryOption.scheduledDeliveryConfig.timeWindows.${number}.start.hours`
      | `localDeliveryOption.scheduledDeliveryConfig.timeWindows.${number}.start.minutes`
      | `localDeliveryOption.rates`
      | `localDeliveryOption.rates.${number}.amount`
      | `localDeliveryOption.rates.${number}.multiplyByQuantity`
      | `localDeliveryOption.deliveryRegionIds`,
      7
    >
  >;
}

export {
  AccountInfo,
  ActionEvent,
  AddDeliveryRegionOptions,
  AddDeliveryRegionRequest,
  AddDeliveryRegionResponse,
  AddressLocation,
  BulkCreateLocalDeliveryOptionRequest,
  BulkCreateLocalDeliveryOptionResponse,
  BulkDeleteLocalDeliveryOptionRequest,
  BulkDeleteLocalDeliveryOptionResponse,
  BulkUpdateLocalDeliveryOptionRequest,
  BulkUpdateLocalDeliveryOptionResponse,
  CityConfig,
  CityItem,
  Condition,
  ConditionType,
  ConditionalRates,
  CreateLocalDeliveryOptionRequest,
  CreateLocalDeliveryOptionResponse,
  CursorPaging,
  CursorPagingMetadata,
  Cursors,
  CustomAreaConfig,
  DayOfWeek,
  DaySlot,
  Days,
  DeleteLocalDeliveryOptionOptions,
  DeleteLocalDeliveryOptionRequest,
  DeleteLocalDeliveryOptionResponse,
  Destination,
  DomainEvent,
  DomainEventBodyOneOf,
  Empty,
  EntityCreatedEvent,
  EntityDeletedEvent,
  EntityUpdatedEvent,
  GetLocalDeliveryOptionOptions,
  GetLocalDeliveryOptionRequest,
  GetLocalDeliveryOptionResponse,
  IdentificationData,
  IdentificationDataIdOneOf,
  LengthUnit,
  ListLocalDeliveryOptionsRequest,
  ListLocalDeliveryOptionsResponse,
  LocalDeliveryAddress,
  LocalDeliveryOption,
  LocalDeliveryOptionConfigOneOf,
  LocalDeliveryOptionError,
  LocalDeliveryOptionQuerySpec,
  LocalDeliveryOptionsQueryBuilder,
  LocalDeliveryOptionsQueryResult,
  LogicalOperator,
  MessageEnvelope,
  Paging,
  QueryLocalDeliveryOptionsRequest,
  QueryLocalDeliveryOptionsResponse,
  QueryV2,
  QueryV2PagingMethodOneOf,
  RadiusConfig,
  RemoveDeliveryRegionOptions,
  RemoveDeliveryRegionRequest,
  RemoveDeliveryRegionResponse,
  RestoreInfo,
  ScheduledDelivery,
  SortOrder,
  Sorting,
  TimeOfDay,
  TimePoint,
  TimeSlot,
  TimeWindow,
  UpdateLocalDeliveryOption,
  UpdateLocalDeliveryOptionRequest,
  UpdateLocalDeliveryOptionResponse,
  WebhookIdentityType,
  ZipCodeConfig,
  utils,
} from './ecom-v1-local-delivery-option-local-delivery-options.universal.js';
